import {FreeSpinsOutroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsOutroState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';

export class GameFreeSpinsOutroState extends FreeSpinsOutroState {

	protected onReelsFadingOutFinished(): void {
		const logic: GameRecodeLogic = this.module.logic as GameRecodeLogic;
		const freeSpinTotalWin: number = logic.freeSpinsTotalWin;
		const freeSpinTotalWinInCents: number = freeSpinTotalWin * 100;

		this.view.showWinSummaryScreen(freeSpinTotalWinInCents);

		logic.goOutOfFreeSpin();

	}
}



// WEBPACK FOOTER //
// ./src/freespins/states/GameFreeSpinsOutroState.ts